module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#group",
      toString: function () {
        return this.url;
      }
    }